<div class="position-relative">
    <mat-form-field ngDefaultControl
                    class="form-checkbox"
                    [class.valid]="internal.value"
                    [class.disabled]="internal.disabled">
        <mat-checkbox [formControl]="internal" [labelPosition]="'before'">{{ label }}</mat-checkbox>
        <input type="text" matInput style="display: none !important;">
    </mat-form-field>
</div>
